import React from 'react';
import CodeVerificationView from '../code-verification-view';

export interface EmailVerificationViewProps {
  email: string;
  isVerifying?: boolean;
  verificationError?: boolean;
  cooldownSeconds?: number;
  showSmsOption?: boolean;
  showTooManyAttempts?: boolean;
  onVerify: (code: string) => void | Promise<void>;
  onClearError: () => void;
  onResendCode: () => Promise<void>;
  onUseSmsVerification: () => void | Promise<void>;
  onChangeEmail: () => void;
  onUsePasswordVerification: () => void;
}

const EmailVerificationView = ({
  email,
  isVerifying = false,
  verificationError = false,
  cooldownSeconds = 0,
  showSmsOption = false,
  showTooManyAttempts = false,
  onVerify,
  onClearError,
  onResendCode,
  onUseSmsVerification,
  onChangeEmail,
  onUsePasswordVerification,
}: EmailVerificationViewProps): React.ReactElement => (
  <CodeVerificationView
    channel="email"
    destination={email}
    isVerifying={isVerifying}
    verificationError={verificationError}
    cooldownSeconds={cooldownSeconds}
    showAlternateChannel={showSmsOption}
    showTooManyAttempts={showTooManyAttempts}
    onVerify={onVerify}
    onClearError={onClearError}
    onResendCode={onResendCode}
    onUseAlternateChannel={onUseSmsVerification}
    onChangeEmail={onChangeEmail}
    onUsePasswordVerification={onUsePasswordVerification}
  />
);

export default EmailVerificationView;
